import Vue from "vue";
import Vuex from "vuex";
import * as actions from './actions';
import * as getters from './getters';

Vue.use(Vuex);

const state = {
    product:{},
    subProducts:[],
    details:{},
    information:{},
    cardToken:'',
    currentStep: 0,
    invoice:{},
    isLoading:false,
    cardError:'',
    clientSecret:'',
    invoiceLink:'',
};

const mutations = {
    SETPRODUCT (state, product){
        state.product = product;

        if(product.sub_products.length > 0)
        {
            state.subProducts = product.sub_products;
        }

        state.details = {
            product: {
                id: state.product.id,
                quantity: 1,
                price: state.product.price
            },
            subProducts: state.subProducts.map(function (item, index) {
                return {
                    id: item.id,
                    title: item.title,
                    quantity: 0,
                    price: item.price,
                    storage_quantity:item.quantity,
                    storage_current_quantity:item.current_quantity
                };
            })
        }

    },
    INCREMENTSTEP (state){
        if (state.currentStep < 2) {
            state.currentStep = state.currentStep + 1;
        }
    },
    DECREMENTSTEP (state){
        if (state.currentStep > 0) {
            state.currentStep = state.currentStep - 1;
        }
    },
    SETSTEP (state, stepNumber){
        state.currentStep = stepNumber;
    },
    SETDETAILS (state, details){
        state.details = details;
    },
    SETINFORMATION (state, information){
        state.information = information;
    },
    SETCARDTOKEN (state, token){
        state.cardToken = token;
    },
    SETINVOICE (state, invoice){
        state.invoice = invoice;
    },
    SETLOADING(state, isLoading){
        state.isLoading = isLoading;
    },
    SETCARDERROR(state, cardError){
        state.cardError = cardError;
    },
    SETCLIENTSECRET(state, clientSecret){
        state.clientSecret = clientSecret;
    },
    SETINVOICELINK(state, link){
        state.invoiceLink = link;
    }

};

export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
});
